// extracted by mini-css-extract-plugin
export default {"panel":"B79d","content":"i6Tf","upseller":"kANB","upgrade-button":"mfeB","upgradeButton":"mfeB"};